import { ControlFacet } from '../models/controls/ControlFacet';
import { IDefaultClickActionHandler } from '../components/actions/defaultClick/DefaultClickAction';

export const defaultClickActionControl = new ControlFacet<{
    itemKey: string;
}, {
        handlers: IDefaultClickActionHandler[];
    }>('defaultClickActionControl');
